// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"244":"e6b44b54","682":"9073aba6","746":"543fd22d","764":"d1466598","966":"d4721a41"}[chunkId] + ".css";
};